import { memo, type JSX } from 'react';
import OfferProductPreview, {
  formDataToPreviewInput,
} from '@/components/ui/OfferProductPreview';
import { OFFER_TYPE_LABELS } from '../BrandOffersPage.constants';
import type { OfferFeedPreviewProps } from '../BrandOffersPage.types';
import { OFFER_FEED_PREVIEW_COPY } from './BrandOfferForm.constants';
import styles from './BrandOfferForm.module.css';

const OfferFeedPreview = ({
  data,
  brandName,
}: OfferFeedPreviewProps): JSX.Element => {
  return (
    <aside
      className={styles.previewColumn}
      aria-label={OFFER_FEED_PREVIEW_COPY.asideAria}
    >
      <div className={styles.previewColumnSticky}>
        <div aria-hidden className={styles.previewAccent} />
        <p className={styles.previewEyebrow}>
          {OFFER_FEED_PREVIEW_COPY.eyebrow}
        </p>
        <h3 className={styles.previewHeading}>
          {OFFER_FEED_PREVIEW_COPY.heading}
        </h3>
        <p className={styles.previewSub}>{OFFER_FEED_PREVIEW_COPY.sub}</p>
        <div className={styles.previewCardShell}>
          <OfferProductPreview
            input={formDataToPreviewInput(data, brandName)}
          />
        </div>
        <p className={styles.previewMetaLine}>
          {OFFER_TYPE_LABELS[data.offerType]}
        </p>
      </div>
    </aside>
  );
};

export default memo(OfferFeedPreview);
